/** @jsxImportSource theme-ui */
import styled from '@emotion/styled'
import { useBreakpointIndex } from '@theme-ui/match-media'
import cookieEater from 'assets/gifs/cookie-eater.gif'
import pergamin from 'assets/images/pergamin.png'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

// TODO convert this to em
const Background = styled.div`
  width: 1350px;
  height: 826px;
  background: url(${pergamin});
  padding: 130px 160px 120px 160px;
  display: flex;
  flex-direction: column;
  position: relative;
  background-size: contain;
`

const CookieEater = styled.div`
  width: 600px;
  height: 265px;
  background-repeat: no-repeat;
  background: url(${cookieEater});
  position: absolute;
  z-index: 3;
  background-size: contain;
  top: -130px;
`

const SmallCookieEater = styled(CookieEater)`
  width: calc(600px * 0.4);
  height: calc(265px * 0.4);
  top: calc(-130px * 0.4);
  margin-left: 40px;
`

const SmallBackground = styled(Background)`
  width: calc(1350px * 0.25);
  height: calc(826px * 0.25);
  padding: calc(130px * 0.25) calc(160px * 0.25) calc(120px * 0.25)
    calc(160px * 0.25);
  margin-top: 70px;
`

const MintingWindowContainer = ({ children }: Props) => {
  const index = useBreakpointIndex()
  return index > 2 ? (
    <Background>
      <CookieEater />
      {children}
    </Background>
  ) : (
    <SmallBackground>
      <SmallCookieEater />
      {children}
    </SmallBackground>
  )
}

export default MintingWindowContainer
